import React from "react";
import Lock from "@material-ui/icons/Lock";
import classnames from "classnames";

export const LockIcon = ({ lockClasses = "", containerClasses = "" }) => {
  return (
    <div
      className={classnames(
        "tw-absolute tw-top-2 tw-right-2 tw-bg-[linear-gradient(124.63deg,#FFD37E_3.13%,#F7AD1E_106.11%)] tw-p-1 tw-rounded-md tw-aspect-[1/1] tw-flex tw-justify-center tw-items-center",
        containerClasses
      )}
    >
      <Lock
        className={classnames("!tw-text-black", lockClasses)}
        fontSize="small"
      />
    </div>
  );
};
